import { useContext, useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import { Box, makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { DatePicker } from "@material-ui/pickers";
import moment from "moment";

import Alert from "@material-ui/lab/Alert";
import { useIntl, FormattedMessage } from "react-intl";

import { TransactionItem } from "../../../../components/transaction_item/TransactionItem";
import {
  YYYY_MM_DD_FORMAT,
  MMM_DD_FORMAT,
  YYYY_MM_DD_HH_MM_FORMAT,
} from "../../../../settings/constants";
import { NewWithdrawRequest } from "./modals/NewWithdrawRequest";
import BusinessService from "../../../../services/BusinessService";
import { ICIPAdminContext } from "../../../../context/ICIPAdminContext";
import { BusinessScopes } from "../../../../models/Business";
import { WithdrawRequests } from "./modals/WithdrawRequests";
interface withDrawRequestTabProps {
  business: number;
}

const useStyles = makeStyles((theme) => ({
  main: {
    minHeight: "75vh",
    width: "100%",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 20,
    paddingBottom: 20,
    overflow: "hidden",
  },
  addButton: {
    textTransform: "none",
    margin: 5,
  },
  title: {
    fontSize: 24,
  },
  divider: {
    width: "100%",
    height: 3,
    backgroundColor: theme.palette.primary.light,
  },
}));

export const WithdrawRequestTab = (props: withDrawRequestTabProps) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const { business } = props;
  const [selectedDate, setSelectedDate] = useState(moment());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const [newRequestModalOpened, setNewRequestModalOpened] = useState(false);
  const toggleNewRequestModal = () => setNewRequestModalOpened(!newRequestModalOpened);
  const [theBusiness, setTheBusiness] = useState(null);
  const [showRequests, setShowRequests] = useState(true);

  const afterNewRequestModalHandle = (succeed: boolean = false) => {
    if (succeed) {
      setNewRequestModalOpened(false);

      //TODO Use reduce to reload requests list
      setShowRequests(false);
      setShowRequests(true);
    }
    else{
      setNewRequestModalOpened(!newRequestModalOpened);
    }
  };


  useEffect(() => {
    async function loadResume() {
      setLoading(true);
      setError(false);

      setLoading(false);
    }
    loadResume();

   BusinessService.getById(business, `${BusinessScopes.accounts}`)
      .then((response) => {
        if (response.isSuccess) {
          if (response.data.code === 100) {
            setTheBusiness(JSON.parse(JSON.stringify(response.data.data)));
            }
          }
        });
  }, [
    business,
    selectedDate,
    formatMessage,
  ]);

  return (
    <>
     {newRequestModalOpened && (
        <NewWithdrawRequest
          business = {theBusiness}
          isOpened={newRequestModalOpened}
          callback={afterNewRequestModalHandle}
        />
      )}
      <Paper className={classes.main} elevation={3}>
        <Grid container spacing={2}>
          <Grid container direction="row" alignItems="center" item xs={12}>
            <Button
              color="secondary"
              variant="contained"
              className={classes.addButton}
              onClick={toggleNewRequestModal}
            >
              <FormattedMessage id="sharedScreen.newWithdrawRequest" />
            </Button>
            {loading && <CircularProgress size={30} />}
            {error && (
              <Alert
                severity="error"
                action={
                  <Button
                    onClick={() => setSelectedDate(moment())}
                    color="inherit"
                    size="small"
                  >
                    <FormattedMessage id="sharedScreen.loadAgain" />
                  </Button>
                }
              >
                <FormattedMessage id="sharedScreen.thereWasAProblemLoadingDatas" />
              </Alert>
            )}
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.title} variant="h4" component="h4">
              <FormattedMessage id="sharedScreen.withdrawalRequestList" />
            </Typography>
          </Grid>
          <Grid container justify="flex-end" item xs={6}>
            <DatePicker
              views={["year", "month", "date"]}
              maxDate={new Date()}
              value={selectedDate}
              onChange={setSelectedDate}
            />
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={3}>
              
            </Paper>
          </Grid>
          <Grid item xs={12}>
            
            { 
            showRequests && (
              <Box component="div">
                <WithdrawRequests 
                businessId = {business} />
            </Box>
            )

            }
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default WithdrawRequestTab;
